import { Form } from 'antd';
import { OrderedCollectionCardsField } from './OrderedCollectionCardsField';
import { SectionDisplayModeField } from './sections/SectionDisplayModeField';
import { SECTION_ROW_DEFAULTS, type SectionRow } from './sections/sectionRows';

interface OrderedSectionCardsFieldProps {
  /** Form.List field name — `sections` on every surface today. */
  name?: string;
  /** Ids already on the record, so their option labels resolve. */
  existingCollectionIds?: number[];
  /** The category the sections belong to. A row pointing at it is the
   * auto-created "All" section, whose mode the server owns. Absent on
   * create, where the category has no id yet. */
  categoryId?: number;
}

/**
 * The category sections editor: ordered collection cards, each with the
 * display mode the client presents it in. Wraps `OrderedCollectionCardsField`
 * so all three surfaces that write `CategoryUpdateIn.sections` — category
 * create, category edit and the home page — stay identical.
 */
export const OrderedSectionCardsField = ({
  name = 'sections',
  existingCollectionIds,
  categoryId,
}: OrderedSectionCardsFieldProps) => {
  const form = Form.useFormInstance();
  // One watch for every row's mode; the rows themselves are watched by the
  // card field, and antd dedups per form.
  const rows = Form.useWatch<SectionRow[] | undefined>(name, form);

  return (
    <OrderedCollectionCardsField
      name={name}
      existingCollectionIds={existingCollectionIds}
      newRowDefaults={SECTION_ROW_DEFAULTS}
      renderRowExtra={({ index, collectionId, collection }) => (
        <SectionDisplayModeField
          index={index}
          mode={rows?.[index]?.display_mode}
          collectionId={collectionId}
          collection={collection}
          categoryId={categoryId}
        />
      )}
    />
  );
};
